import { type FC } from 'react'
import classNames from 'classnames'
import styles from './Tags.module.scss'
import { hueForTag, tagHueClass } from '../workflowTags'

interface HashtagChipsProps {
  tags: string[]
  max?: number
  selected?: string | null
  onSelect?: (tag: string) => void
}

const CHIP_CLASS = 'd-inline-flex align-items-center zocks-px-0.75 zocks-py-0.125 rounded-2 paragraph-extra-small border'

export const HashtagChips: FC<HashtagChipsProps> = ({ tags, max, selected, onSelect }) => {
  if (tags.length === 0) {
    return null
  }
  const visible = max === undefined ? tags : tags.slice(0, max)
  const overflow = tags.length - visible.length
  return (
    <div className='d-flex flex-wrap gap-1'>
      {visible.map((tag, index) => {
        const className = classNames(CHIP_CLASS, tagHueClass(hueForTag(tag)), {
          'zocks-border-color-gray-900': selected === tag,
          'zocks-border-color-gray-200': selected !== tag,
        })
        return onSelect ? (
          <button
            key={`${tag}-${index}`}
            type='button'
            className={classNames(className, styles.chipInteractive)}
            aria-pressed={selected === tag}
            onClick={() => onSelect(tag)}
          >
            #{tag}
          </button>
        ) : (
          <span key={`${tag}-${index}`} className={className}>
            #{tag}
          </span>
        )
      })}
      {overflow > 0 ? <span className={classNames(CHIP_CLASS, 'zocks-text-gray-600')}>+{overflow}</span> : null}
    </div>
  )
}
